import type { ExcelDownloadClient } from "app/components/React/ExcelButton/ExcelClientDownload";
import { createStaticListUrl } from "app/pages/sales-intelligence/sub-modules/opportunities/services/api/utils";
import type { IFetchService } from "app/services/fetchService";

import type {
    ContactsExportRequestDto,
    RevealedContactsResponseDto,
    TopNRevealRequestDto,
} from "../../../contacts-search/types/dto";
import type { OpportunityListType } from "../../types";

function createStaticListsWebsitesApiService(fetchService: IFetchService, excelDownloadClient: ExcelDownloadClient) {
    const createLeadsPath = (listId: OpportunityListType["opportunityListId"], path?: string): string => {
        const baseListPath = createStaticListUrl(listId);

        return `${baseListPath}/opportunities${path ?? ""}`;
    };

    return {
        revealTopNContacts(
            listId: OpportunityListType["opportunityListId"],
            dto: TopNRevealRequestDto,
        ): Promise<RevealedContactsResponseDto> {
            return fetchService.post(createLeadsPath(listId, "/contacts/reveal"), dto);
        },
        exportStaticListContactsToExcel(
            listId: OpportunityListType["opportunityListId"],
            dto: ContactsExportRequestDto,
        ) {
            return excelDownloadClient(createLeadsPath(listId, "/contacts/excel"), dto);
        },
    };
}

function createStaticListsCompaniesApiService(fetchService: IFetchService, excelDownloadClient: ExcelDownloadClient) {
    const createLeadsPath = (listId: OpportunityListType["opportunityListId"], path?: string): string => {
        const baseListPath = createStaticListUrl(listId);

        return `${baseListPath}/companies${path ?? ""}`;
    };

    return {
        revealTopNContacts(
            listId: OpportunityListType["opportunityListId"],
            dto: TopNRevealRequestDto,
        ): Promise<RevealedContactsResponseDto> {
            return fetchService.post(createLeadsPath(listId, "/contacts/reveal"), dto);
        },
        exportStaticListContactsToExcel(
            listId: OpportunityListType["opportunityListId"],
            dto: ContactsExportRequestDto,
        ) {
            return excelDownloadClient(createLeadsPath(listId, "/contacts/excel"), dto);
        },
    };
}

export default function createStaticListsApiService(
    fetchService: IFetchService,
    excelDownloadClient: ExcelDownloadClient,
) {
    return {
        companies: createStaticListsCompaniesApiService(fetchService, excelDownloadClient),
        websites: createStaticListsWebsitesApiService(fetchService, excelDownloadClient),
    };
}
